import React from 'react';
import { Text } from '@react-three/drei';

function PowerGrid2({
  position = [0, 0, 0],
  height = 6,
  width = 4,
  component,
  onHover,
  onClick,
}) {
  return (
    <group position={position}>
      {/* Main wooden pole */}
      <mesh
        position={[0, height / 4, 0]}
        onPointerOver={() => onHover?.(component?.name)}
        onPointerOut={() => onHover?.(null)}
        onClick={() => onClick?.(component)}
      >
        <cylinderGeometry args={[0.15, 0.15, height, 16]} />
        <meshStandardMaterial color='#8B4513' />
      </mesh>
      {/* Horizontal crossbar */}
      <mesh position={[0, height / 1.5, 0]}>
        <boxGeometry args={[width, 0.2, 0.2]} />
        <meshStandardMaterial color='#5c3317' />
      </mesh>
      {/* Small insulators (3 pieces on top) */}
      {[-width / 2.5, 0, width / 2.5].map((x, i) => (
        <mesh key={i} position={[x, height / 1.42, 0]}>
          <cylinderGeometry args={[0.1, 0.1, 0.2, 16]} />
          <meshStandardMaterial color='black' />
        </mesh>
      ))}
      {/* Wires - shorter & slightly angled (half pole height) */}
      {[-width / 2.5, 0, width / 2.5].map((x, i) => (
        <mesh key={i} position={[x, height / 1.46, 0]} rotation={[0, 0, -1]}>
          <cylinderGeometry args={[0.02, 0.02, height / 2, 16]} />
          <meshStandardMaterial color='black' />
        </mesh>
      ))}
      {/* Label above */}
      {/* Decorative top label */}
      <group position={[8, height - 2, 0]}>
        {/* First line - BIG FONT */}
        <Text
          fontSize={1.2}
          color='black'
          anchorX='center'
          anchorY='middle'
          outlineColor='#000000ff'
          outlineWidth={0.01}
          fontWeight={700}
          position={[0, 0, 0]}
        >
          {'Grid & House \nLoad'}
        </Text>

        {/* Next 2 lines - SMALL FONT only if value exists */}
        {(component.details?.Brand_name ||
          component.details?.Quantity ||
          component.details?.Specification) && (
          <Text
            fontSize={0.9}
            color='black'
            anchorX='center'
            anchorY='top'
            position={[0, -1.4, 0]}
          >
            {`${component.details?.Brand_name || ''}\nx${component.details?.Quantity || '0'}\n${component.details?.Specification || ''}`}
          </Text>
        )}
      </group>
    </group>
  );
}

export default PowerGrid2;
